(function () {
  'use strict';

  var SECTION_SEL = '[data-section-type="collection-template"]';
  var CONTAINER_SEL = '[data-product-container]';
  var ITEM_SEL = '.sf__col-item';
  var LOADMORE_SEL = '[data-load-more]';
  var TTL = 30 * 60 * 1000;
  var KEY_PREFIX = 'ulip-coll:';

  var section = document.querySelector(SECTION_SEL);
  if (!section) return;

  var paginationType = section.dataset.paginationType;
  if (paginationType !== 'loadmore' && paginationType !== 'infinite') return;

  var container = section.querySelector(CONTAINER_SEL);
  if (!container) return;

  var pageSize = parseInt(container.dataset.pageSize, 10) || 12;
  var totalPages = parseInt(container.dataset.totalPages, 10) || 1;
  var sectionId = section.dataset.sectionId;

  function stateKey() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    return KEY_PREFIX + url.pathname + url.search;
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(stateKey());
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > TTL) return null;
      return data;
    } catch (e) { return null; }
  }

  function writeState(patch) {
    try {
      var current = readState() || {};
      var next = Object.assign({}, current, patch, { ts: Date.now() });
      sessionStorage.setItem(stateKey(), JSON.stringify(next));
    } catch (e) {}
  }

  function loadedPage() {
    var count = container.querySelectorAll(ITEM_SEL).length;
    return Math.max(1, Math.ceil(count / pageSize));
  }

  var lastClickedProductId = null;
  section.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var card = link.closest('[data-product-id]');
    lastClickedProductId = card ? card.dataset.productId : null;
  }, true);

  window.addEventListener('pagehide', function (event) {
    writeState({
      page: loadedPage(),
      productId: lastClickedProductId,
      scrollY: window.scrollY
    });
    // Se a página vai para o bfcache, o navegador conseguirá restaurar
    // DOM e scroll juntos — pedir 'auto' evita o flash de scroll=0 no Safari.
    // Caso contrário, mantemos 'manual' para nós controlarmos a restauração
    // depois que as páginas extras forem buscadas via fetch.
    if ('scrollRestoration' in history) {
      history.scrollRestoration = event.persisted ? 'auto' : 'manual';
    }
  });

  function buildPageUrl(n) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', n);
    return url.toString();
  }

  function fetchPage(n) {
    return fetch(buildPageUrl(n), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('page ' + n);
        return res.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return Array.prototype.slice.call(tmp.querySelectorAll(CONTAINER_SEL + ' ' + ITEM_SEL));
      });
  }

  function performScroll(state) {
    var card = state.productId
      ? container.querySelector('[data-product-id="' + (window.CSS && CSS.escape ? CSS.escape(state.productId) : state.productId) + '"]')
      : null;
    if (card) {
      card.scrollIntoView({ block: 'center' });
    } else if (typeof state.scrollY === 'number') {
      window.scrollTo(0, state.scrollY);
    }
  }

  function restore(state) {
    var target = Math.min(state.page || 1, totalPages);
    var loaded = loadedPage();

    if (target <= loaded) {
      requestAnimationFrame(function () { performScroll(state); });
      return;
    }

    var promises = [];
    for (var p = loaded + 1; p <= target; p++) promises.push(fetchPage(p));

    Promise.all(promises).then(function (pages) {
      var grid = container.firstElementChild;
      if (!grid) return;
      var frag = document.createDocumentFragment();
      pages.forEach(function (items) {
        items.forEach(function (item) { frag.appendChild(item); });
      });
      grid.appendChild(frag);

      try {
        if (window.MinimogTheme && MinimogTheme.Collection) {
          MinimogTheme.Collection.currentPage = target;
        }
      } catch (e) {}

      if (target >= totalPages) {
        var btn = section.querySelector(LOADMORE_SEL);
        if (btn && btn.parentNode && btn.parentNode.parentNode) btn.parentNode.remove();
      }

      try {
        if (window.MinimogEvents && MinimogEvents.emit) MinimogEvents.emit('ON_PRODUCT_LIST_UPDATED');
      } catch (e) {}

      requestAnimationFrame(function () { performScroll(state); });
    }).catch(function (err) {
      console.error('[ulip] scroll-restore failed', err);
      requestAnimationFrame(function () { performScroll(state); });
    });
  }

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  window.addEventListener('pageshow', function (event) {
    var state = readState();
    if (!state) return;

    if (event.persisted) {
      // bfcache: o pagehide anterior trocou scrollRestoration para 'auto', então
      // o navegador já restaurou DOM + scroll sem flash. Nada a fazer aqui.
      return;
    }

    if ((state.page || 1) <= 1) {
      if (state.scrollY > 0) {
        requestAnimationFrame(function () { performScroll(state); });
      }
      return;
    }
    var attempts = 0;
    var tryRestore = function () {
      attempts++;
      var ready = window.MinimogTheme && MinimogTheme.Collection && MinimogTheme.Collection.domNodes;
      if (ready || attempts > 40) {
        restore(state);
      } else {
        setTimeout(tryRestore, 50);
      }
    };
    tryRestore();
  });
})();
